import { Inject, Options, Vue } from "vue-property-decorator";
import LoadingIndicator from "@/shared/components/loading-indicator/index.vue";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import { ComplianceForm, PartBFormPracticeAccountRequest } from "@/shared/modules/typescript-trustapi-client/models";
import ModalBox from "@/shared/components/modal-box/index.vue";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";

@Options({
  props: {
    selectedBank: Object,
  },
  components: {
    ModalBox,
    LoadingIndicator,
    ErrorIndicator,
  }
})
export default class AddBankModal extends Vue {
  private selectedBank!: any;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private ai = new AppInsights;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private id = 0;
  private bankName = '';
  private bsbno = '';
  private accountNo = '';

  private isEditMode = false;

  private submitting = false;
  private error = false;
  private formDirty = false;

  mounted(): void {
    if (this.selectedBank) {
      this.id = this.selectedBank.id || 0;
      this.bankName = this.selectedBank.bankName;
      this.bsbno = this.selectedBank.bsbno;
      this.accountNo = this.selectedBank.accountNo;
      this.isEditMode = true;
    }
  }

  private async save(): Promise<void> {
    this.formDirty = true;
    if (this.bankName === '' || this.bsbno === '' || this.accountNo === '') {
      return;
    }
    const body: PartBFormPracticeAccountRequest = {
      id: this.id,
      bankName: this.bankName,
      bsbno: this.bsbno.replace(/\D/g, ''),
      accountNo: this.accountNo,
      complianceFormId: this.complianceFormB.id,
      updatingKey: this.updatingKey,
      manageSignatoryUpdatingKey: this.signatoriesUpdatingKey
    };
    this.submitting = true;

    try {
      if (this.isEditMode) {
        await this.apiService.PartBFormApi?.apiV2PartBFormUpdateFormPracticeAccountPost(body)
      } else {
        await this.apiService.PartBFormApi?.apiV2PartBFormAddFormPracticeAccountPost(body)
      }
      this.eventCtrl.emit('show-snackbar', 'success', 'Bank account saved successfully');
      this.eventCtrl.emit('reload-form-b-gtm-content');
      this.submitting = false;
      this.closeModal();
    } catch (err) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error ' + (this.isEditMode ? 'saving ' : 'adding ') + 'bank account');
      this.ai.trackException('Error ' + (this.isEditMode ? 'saving ' : 'adding ') + ' bank account: ' + err);
      this.error = true;
      console.log(err);
    } finally {
      this.submitting = false;
    }
    Promise.resolve();
  }

  private closeModal(): void {
    this.$emit('close');
  }

  get complianceFormB(): ComplianceForm {
    return store.getters.getSelectedComplianceFormB;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  get signatoriesPracticeCoreId(): number | null {
    return store.getters.getSelectedPracticeCoreId;
  }

  get signatoriesUpdatingKey(): string {
    return store.getters.getSignatoriesUpdatingKey;
  }

}

